import { useLang } from '@/i18n';
import { Collapse } from 'antd';
import styles from './index.module.scss';

const FAQSection = () => {
    const { t } = useLang('theProduct.FAQSection');
    const list: any = [
        {
            q: 'q1',
            a: `a1`,
        },
        {
            q: 'q2',
            a: `a2`,
        },
        {
            q: 'q3',
            a: `a3`,
        },
        {
            q: 'q3-1',
            a: `a3-1`,
        },
        {
            q: 'q4',
            a: `a4`,
        },
        {
            q: 'q5',
            a: `a5`,
        },
        {
            q: 'q6',
            a: `a6`,
        },
        {
            q: 'q7',
            a: `a7`,
        },
        {
            q: 'q8',
            a: `a8`,
        },
        {
            q: 'q9',
            a: `a9`,
        },
        {
            q: 'q10',
            a: `a10`,
        },
        {
            q: 'q11',
            a: `a11`,
        },
        {
            q: 'q12',
            a: `a12`,
        },
        {
            q: 'q13',
            a: `a13`,
        },
    ];
    return (
        <section className={styles.faqSection} id="FAQSection" data-section-id={styles.faqSection} data-section-title={t(`title`)}>
            <div className="text-container">
                <h2 className="title">{t(`title`)}</h2>
                <p className="intro">{t(`desc`)}</p>
            </div>
            <div className="content">
                <Collapse
                    ghost={true}
                    className="collapse-lists"
                    defaultActiveKey={0}
                    // onChange={setActive}
                    // accordion={true}
                    expandIcon={({ isActive }: any) => {
                        return (
                            <svg
                                className={`collapse-icon ${isActive ? 'active' : ''}`}
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                            >
                                <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        );
                    }}
                    expandIconPosition="right"
                >
                    {list?.map((item: any, k: number) => (
                        <Collapse.Panel className="list-title" key={item.q} header={t(item.q)}>
                            <p className="list-desc" style={{ whiteSpace: 'pre-line' }}>
                                {t.rich(item.a, {
                                    a: (text: string) => (
                                        <a className="link" href={`mailto:${text}`}>
                                            {text}
                                        </a>
                                    ),
                                    span: (text: string) => (
                                        <a className="link" href="https://www.ecoflow.com/us/installer-near-me">
                                            {text}
                                        </a>
                                    ),
                                    p: (text: string) => (
                                        <a className="link" href="https://www.ecoflow.com/us/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage">
                                            {text}
                                        </a>
                                    ),
                                    li: (text: string) => (
                                        <a className="link" href="https://us.ecoflow.com/">
                                            {text}
                                        </a>
                                    ),
                                })}
                            </p>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
        </section>
    );
};

export default FAQSection;
